import { render, staticRenderFns } from "./EditItemFields.vue?vue&type=template&id=41338ead&scoped=true&"
import script from "./EditItemFields.vue?vue&type=script&lang=js&"
export * from "./EditItemFields.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EditItemFields.vue?vue&type=style&index=1&id=41338ead&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41338ead",
  null
  
)

export default component.exports